import { render, staticRenderFns } from "./BlockTitle.vue?vue&type=template&id=53de0c90&scoped=true&"
import script from "./BlockTitle.vue?vue&type=script&lang=js&"
export * from "./BlockTitle.vue?vue&type=script&lang=js&"
import style0 from "./BlockTitle.vue?vue&type=style&index=0&id=53de0c90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53de0c90",
  null
  
)

export default component.exports